'use client';

import { useTranslations } from 'next-intl';
import { InfoIcon } from '@/lib/components/InfoIcon';
import { Text } from '@/lib/ui-kit/text';
import { Tooltip, TooltipContent, TooltipTrigger } from '@/lib/ui-kit/tooltip';

/**
 * Right-hand value of a summary row when the book has no liquidity on the
 * side being traded. One component so Buy and Sell (and the empty-form
 * PotentialPayout row) render the placeholder identically: regular weight,
 * secondary color, the same gap before the info icon.
 */
export function NoOffersHint() {
  const t = useTranslations('orderForm');

  return (
    <span className="inline-flex items-center gap-1 text-[13px] leading-4 font-normal tracking-[-0.13px] text-v2-text-secondary">
      <span>{t('noOffers')}</span>
      <Tooltip>
        <TooltipTrigger asChild>
          <span>
            <InfoIcon />
          </span>
        </TooltipTrigger>
        <TooltipContent side="top" sideOffset={8} className="max-w-[220px] px-2 py-1.5 !text-left">
          <Text variant="label-md">{t('noOffersTooltip')}</Text>
        </TooltipContent>
      </Tooltip>
    </span>
  );
}
